import { CreateDeliveryFee } from "@/pages/delivery-fee/create-delivery-fee";
import DeliveryFeesPage from "@/pages/delivery-fee/delivery-fee-page";
import { EditDeliveryFee } from "@/pages/delivery-fee/edit-delivery-fee";
import MediaManagementPage from "@/pages/media-management-page";
import { CreateMessageTemplate } from "@/pages/message-template/create-message-template";
import { EditMessageTemplate } from "@/pages/message-template/edit-message-template";
import MessageTemplatePage from "@/pages/message-template/message-template-page";
import ReportsPage from "@/pages/report/report-page";
import SettingsPage from "@/pages/setting-page";
import StockMovementsPage from "@/pages/stock-movement/stock-movement-page";
import StoresPage from "@/pages/stores";
import { RouteType } from "../types";
import { route } from "../utils";

// Define routes with semantic names - single source of truth
export const operationsRoutes: Record<string, RouteType> = {
  stores: route("/stores", StoresPage),
  stockMovements: route("/stock-movements", StockMovementsPage),
  reports: route("/reports", ReportsPage),
  deliveryFees: route("/delivery-fees", DeliveryFeesPage),
  createDeliveryFee: route("/delivery-fees/create", CreateDeliveryFee),
  editDeliveryFee: route("/delivery-fees/:id/edit", EditDeliveryFee),
  settings: route("/settings", SettingsPage),
  messageTemplates: route("/message-templates", MessageTemplatePage),
  createMessageTemplate: route(
    "/message-templates/create",
    CreateMessageTemplate
  ),
  editMessageTemplate: route(
    "/message-templates/:id/edit",
    EditMessageTemplate
  ),
  mediaManagement: route("/media-management", MediaManagementPage),
};
